import { styled, colors } from '../../styles/base/_allBase.styles'

export const Panel = styled.aside`
  width:100%;padding:2.4rem;background:${colors.coolPalette.neutralLight};border-top:4px solid ${colors.warmPalette.primary};border-radius:.4rem;box-shadow:0 1.2rem 3rem rgba(24,47,53,.08);
`
export const Row = styled.div`
  padding:1rem 0;border-bottom:1px solid rgba(24,47,53,.14);font-size:1.5rem;line-height:1.5;color:${colors.warmPalette.primaryDark};
  &:last-child{border-bottom:0;} strong{font-weight:800;}
`
export const PanelLink = styled.a`
  display:inline-flex;align-items:center;min-height:4.4rem;color:${colors.warmPalette.primary};font-weight:800;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:.35rem;
  &:hover{color:${colors.warmPalette.textAccent};}
`
